import { Component, Input, OnInit } from '@angular/core';
import { Section } from 'src/app/model/shared/section';

@Component({
  selector: 'app-api-reference-accordion-section',
  templateUrl: './api-reference-accordion-section.component.html',
  styleUrls: ['./api-reference-accordion-section.component.scss']
})
export class ApiReferenceAccordionSectionComponent implements OnInit {
  @Input() apiReferenceAccordianSections: Section[] = [];
  @Input() isDefault: boolean = true;
  @Input() responsePage: boolean = false;

  collapsed: boolean[] = [];
  isIconTrue: boolean[] = [];

  constructor() {}

  ngOnInit(): void {
    this.apiReferenceAccordianSections?.forEach((i) => {
      this.collapsed.push(false);
    });
  }

  toggleCollapsed(index: number) {
    this.collapsed[index] = !this.collapsed[index];
    this.isIconTrue[index] = !this.isIconTrue[index];
  }

  getAccordionStyle(index: number) {
    return this.collapsed[index] ? 'not-collapsed' : 'collapsed';
  }

  getArrowIcons(index: number) {
    return this.isIconTrue[index] ? 'icon-arrowUp' : 'icon-arrowDown';
  }
}
